import React from "react";
import { portfolioData } from "../data/portfolioData";

const Experience = () => {
  const { experience, sections } = portfolioData;

  return (
    <section id="experience" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">{sections.experienceTitle}</h2>
        <ol className="mt-8 space-y-5">
          {experience.map((exp) => (
            <li key={`${exp.company}-${exp.period}`}>
              <article className="rounded-2xl border border-slate-200 bg-white/85 p-6 shadow-lg shadow-indigo-100/50">
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-indigo-700">
                  {exp.period}
                </p>
                <h3 className="mt-2 text-xl font-semibold text-slate-900">{exp.role}</h3>
                <p className="mt-1 text-sm text-slate-700">{exp.company}</p>
                {exp.highlights?.length > 0 && (
                  <ul className="mt-4 space-y-2 text-sm text-slate-700">
                    {exp.highlights.map((point) => (
                      <li key={point} className="flex gap-2">
                        <span className="mt-[0.35rem] h-1.5 w-1.5 rounded-full bg-indigo-600" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Experience;
